module.exports = __webpack_public_path__ + "static/img/beauty.6e03482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beauty.png
// module id = IIMe
// module chunks = 0